import AvatarStack from "@pathwright/ui/src/components/avatar/AvatarStack"
import classnames from "classnames"
import PropTypes from "prop-types"
import styled from "styled-components"
import InboxNavigatorItemReviewCount from "./InboxNavigatorItemReviewCount"
import { inboxNavigatorItemPropType } from "./propTypes"
import { InboxGroupNode } from "./useInboxItems"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .InboxNavigatorItemReviewCount {
    margin-left: 1em;
    font-size: 1.2em;
  }

  .Button__content-wrapper {
    .CountIndicator {
      position: absolute;
      top: 0px;
      right: 0px;
    }
  }
`

const IdentifierContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow: hidden;

  h1 {
    font-size: 1.2em;
    margin: 0;
    margin-bottom: 0.2em;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
  }

  h1 + div {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.5);

    h2 {
      font-size: 1em;
      margin: 0;
      margin-left: 0.4em;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
      overflow: hidden;
    }
  }
`

const InboxNavigatorItemMeta = ({ item }: { item: InboxGroupNode }) => (
  <IdentifierContainer className="InboxNavigatorItem__meta">
    <h1>{item.meta.title}</h1>
    <div>
      <AvatarStack
        users={[...item.users.staff, ...item.users.members]}
        size="1.6em"
        itemOffset="-0.4em"
      />
      {/* <AvatarStack users={item.users.members} size="1.6em" itemOffset="-0.4em" /> */}
      <h2>{item.meta.subtitle}</h2>
    </div>
  </IdentifierContainer>
)

const InboxNavigatorItem = ({
  className,
  item,
  onSelect
}: {
  className?: string
  item: InboxGroupNode
  onSelect: () => void
}) => (
  <Container
    className={classnames(
      "InboxNavigatorItem",
      `InboxNavigatorItem__${item.type}`,
      className
    )}
    onClick={onSelect}
  >
    <InboxNavigatorItemMeta item={item} />
    <InboxNavigatorItemReviewCount item={item} />
  </Container>
)

InboxNavigatorItem.displayName = "InboxNavigatorItem"

InboxNavigatorItem.propTypes = {
  item: inboxNavigatorItemPropType.isRequired,
  onSelect: PropTypes.func.isRequired,
  onSelectPending: PropTypes.func.isRequired
}

InboxNavigatorItem.defaultProps = {}

export default InboxNavigatorItem
